import {
  clearAuthToken,
  hasStoredAuthToken,
} from '../../../../corelogic/domain/utils/authStorage.utils';
import { restoreAuthFromStorage } from '../../../../corelogic/state/authentication/authentication.action';
import { store } from '../../../../corelogic/state/store';

export class AppInitializationService {
  /**
   * Initialize the application, including authentication restoration
   */
  static async initializeApp(): Promise<void> {
    console.log('🚀 Initializing app...');

    try {
      // Check if there's a stored authentication token
      if (hasStoredAuthToken()) {
        console.log(
          '📱 Found stored token, attempting to restore authentication...',
        );

        // Dispatch action to restore authentication from storage
        store.dispatch(restoreAuthFromStorage());
      } else {
        console.log('🔒 No stored token found, user needs to sign in');
      }

      console.log('✅ App initialization completed');
    } catch (error) {
      console.error('❌ App initialization failed:', error);
      // Continue with app load even if restoration fails
      // The user will just need to sign in again
    }
  }

  /**
   * Clear all stored data and reset app state
   */
  static clearAppData(): void {
    console.log('🧹 Clearing app data...');

    try {
      // Clear authentication data
      clearAuthToken();

      console.log('✅ App data cleared successfully');
    } catch (error) {
      console.error('❌ Failed to clear app data:', error);
    }
  }
}
